import { render, staticRenderFns } from "./beyondLimit.vue?vue&type=template&id=0210ac32&scoped=true"
import script from "./beyondLimit.vue?vue&type=script&lang=js"
export * from "./beyondLimit.vue?vue&type=script&lang=js"
import style0 from "./beyondLimit.vue?vue&type=style&index=0&id=0210ac32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0210ac32",
  null
  
)

export default component.exports